import { createTheme } from '@material-ui/core/styles';
import common from './common';
import palette from './palette';
import { typography } from './typography';
import { fontFamily, fontSize, fontWeight, htmlBodyFontSize } from '../font';
import Banner from './banner';
import images from './images';
import views from './views';
import overrides from './overrides';

// light or default theme
const theme = {
  themeName: 'light',
  // palette
  palette: {
    ...palette,
  },
  font: {
    htmlBodyFontSize: htmlBodyFontSize,
    fontFamily: fontFamily,
    fontWeight: fontWeight,
    fontSize: fontSize,
  },

  // common styles
  ...common,
  banner: { ...Banner },
  // styles old. do not use it
  input: {
    color: palette.text.primary,
  },
  tip: {
    color: '#767C9E',
    fontSize: fontSize._12,
    display: 'block',
  },
  contentLayout: {
    backgroundColor: '#FEFEFE',
    color: '#7777C1',
    borderColor: '#EFF2F7',
    accentBackgroundColor: '#F4F6F9',
    boxShadow: '0 5px 11px 0 rgba(63,90,151,0.06)',
    greyColor: '#B0B0B0',
  },
  // components old
  radioInput: {
    color: '#36425A',
  },
  imageArray: {
    backgroundColor: '#FAFBFF',
    border: '1px dashed #7777C1',
  },
  picker: {
    backgroundColor: '#FFFFFF',
    hoverBackgroundColor: '#EFF2F7',
  },
  tooltip: {
    backgroundColor: '#ffffff',
    color: '#01082B',
  },
  searchInput: {
    backgroundColor: '#FFFFFF',
  },
  tableAmountField: {
    backgroundColor: '#F8F9FB',
    labelColor: '#74C3C4',
    color: '#36425A',
  },
  tableTextField: {
    labelColor: '#74C3C4',
  },
  tableAmountReuseField: {
    backgroundColor: '#F8F9FB',
    labelColor: '#74C3C4',
    color: '#36425A',
  },
  tableDeleteField: {
    backgroundColor: '#F8F9FB',
  },
  //check on UI
  myPerformance: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #F0F2F6',
  },
  loader: {
    backgroundColor: 'rgb(250, 251, 252, 0.3)',
  },
  alphabeticalPicker: {
    backgroundColor: '#FFFFFF',
    borderWidth: '1px !important',
    borderColor: '#DADFEC !important',
    option: {
      selected: {
        backgroundColor: '#DADFEC !important',
      },
    },
  },
  //views
  ...views,
  // MUI component overrides
  overrides: { ...overrides },
  //typography
  typography: { ...typography },
  //defined theme images
  images: {
    ...images,
  },
};

export default createTheme(theme);
